/**
 * Portal Entry Point for Key Management Domain
 *
 * This file registers all pages and custom CRUD components with the portal system.
 */

import { registerBlockComponent } from "@ja/crud/services/componentRegistry";
import { registerPage } from "@ja/portal/pageRegistry";

// Register custom CRUD components
registerBlockComponent(
    "KeyManagement::AssignmentDialog",
    () => import("./Components/KeyAssignmentDialog.vue"),
    "key-management"
);

registerBlockComponent(
    "KeyManagement::AssignmentStatus",
    () => import("./Components/KeyAssignmentStatus.vue"),
    "key-management"
);

// Register pages with the portal
registerPage(
    "key-management",
    "Base/MyKeys",
    () => import("./Pages/MyKeys.vue")
);

registerPage(
    "key-management",
    "Base/BatchAssignment",
    () => import("./Pages/BatchAssignment.vue")
);
